import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { techRadarApi } from '@backstage-community/plugin-tech-radar/alpha';
import { techRadarApiRef } from '@backstage-community/plugin-tech-radar';
import { agmTechRadarData } from './data';

/**
 * Overrides the tech-radar plugin's default API (which otherwise falls back
 * to mock data with no tech-radar-backend installed) with a static,
 * client-side AGM dataset. See ./data.ts to update entries.
 */
const agmTechRadarApi = techRadarApi.override({
  params: defineParams =>
    defineParams({
      api: techRadarApiRef,
      deps: {},
      factory: () => ({
        load: async () => agmTechRadarData,
      }),
    }),
});

export const techRadarModule = createFrontendModule({
  pluginId: 'tech-radar',
  extensions: [agmTechRadarApi],
});
